import React from "react";

import "./SuspenseLoader.less";

import SvgLoader from "../SvgLoader/SvgLoader";

export default function SuspenseLoader() {
  return (
    <div className="SuspenseLoader" aria-label="Loader">
      <SvgLoader />
    </div>
  );
}
